import { render, staticRenderFns } from "./PanelistBagsManagement.vue?vue&type=template&id=69c06b0b"
import script from "./PanelistBagsManagement.vue?vue&type=script&lang=js"
export * from "./PanelistBagsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports